// eslint-disable-next-line import/prefer-default-export
export const INACTIVE_CLIENT_STATUS = 'inactive';
